// Generated by ReScript, PLEASE EDIT WITH CARE

import * as FontAwesome$Web from "./FontAwesome.res.js";
import * as JsxRuntime from "react/jsx-runtime";

function Spinner(props) {
  return JsxRuntime.jsx("span", {
    children: JsxRuntime.jsx(FontAwesome$Web.Solid.make, {
      name: "spinner",
      spin: true
    }),
    className: "icon"
  });
}

let make = Spinner;

export {
  make,
}
/* FontAwesome-Web Not a pure module */
